import React from 'react';

interface TeethSvgPimModelProps {
  swapLinearComponent: any;
}

export default function TeethSvgModelPim({ swapLinearComponent }: TeethSvgPimModelProps) {
  const hexagonPoints = (cx: number, cy: number, r: number) => {
    let points = [];
    for (let i = 0; i < 6; i++) {
      let angle = (Math.PI / 3) * i;
      let x = cx + r * Math.cos(angle);
      let y = cy + r * Math.sin(angle);
      points.push(`${x},${y}`);
    }
    return points.join(' ');
  };
  return (
    <>
      {swapLinearComponent}
      {/* teeth */}
      {/* upper */}
      <g data-role="teethGroup">
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 6.1965 392.1194)" className="st1 st2">
            18
          </text>
          <g data-role="pim">
            <polygon className="st3" points={hexagonPoints(70, 390, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="70" cy="390" r="14" fill="rgba(255, 255, 255,0)" />
          </g>

          <g data-role="abutment">
            <circle className="st3" cx="70" cy="390" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st3"
              points={hexagonPoints(70, 390, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>

          <path
            className="st3"
            d="M75.44,360.69c-3.1-0.45-7.68-1.61-11.56-2.52s-9.27-2.95-9.27-2.95s-6.71,1.01-10.52,6.94
		c-3.8,5.93-3.92,12.08-3.13,15.77c0.35,1.66,1.23,3.78,2.18,5.37c0,0,0.45,5.31,1.46,8.04c0.19,0.5-0.02,1.11,0,1.74
		c0.18,4.32,1.07,7.58,1.3,8.94c0.24,1.36,1.72,4.38,3.79,5.98c2.07,1.6,4.56,4.03,9.36,4.62c0,0,5.45,2.96,13.68,3.14
		c0,0,2.78,0.3,4.03,0.65c1.24,0.36,7.82,1.07,13.2-2.01c5.39-3.08,10.26-7.47,11.08-8.62c0.82-1.15,2.05-2.62,2.3-3.94
		c0,0,5.08-7.46,4.92-12.96s-1.39-14.6-5.17-17.96s-7.14-7.55-15.66-10.17c-0.73,0.32-2.04,0.78-2.04,0.78
		C83.35,362.31,78.54,361.15,75.44,360.69z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 5.3464 326.4305)" className="st1 st2">
            17
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(73, 330, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="73" cy="330" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st3" cx="73" cy="330" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(73, 330, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M89.03,300.71c-1.79-0.05-4.8-0.47-7.49-1.32c-2.68-0.85-4.8-1.22-7.91-1.98c-3.11-0.75-8.86-2.97-12.01-4.24
		c-3.16-1.27-6.31-3.2-6.31-3.2s-6.08,1.47-9.58,4.48c-3.5,3.01-6.78,6.78-7.62,13.71c0,0-1.01,9.1,1.38,12.29c0,0,0,6.93,0.74,8.83
		c0,0-0.98,7.29,0.74,14.1c0,0,0.86,3.92,4.72,6.74c0,0,3,3.75,8.95,5.12c0,0,5.39,2.04,9.27,2.95s8.46,2.07,11.56,2.52
		c3.1,0.45,7.91,1.62,9.94,0.84c0,0,1.31-0.45,2.04-0.78c0,0,7.47-3.17,12-6.97c0,0,4.84-3.25,6.25-6.56c0,0,6.62-8.89,6.56-14.65
		c-0.06-5.76-0.18-14.22-3.8-18.51c-3.61-4.29-7.47-9.37-15.79-13.47C92.65,300.59,90.82,300.75,89.03,300.71z"
          />
        </g>

        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 9.6095 254.4317)" className="st1 st2">
            16
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(75, 263, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="75" cy="263" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="75" cy="263" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(75, 263, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M73.44,221.75c-2.81-0.66-5.36-1.77-5.36-1.77l-0.23-0.04c-0.76-0.11-3.5-0.26-8.94,1.75
		c-6.51,2.4-9.04,7.02-9.04,7.02c-2.59,2.28-4.11,6.51-4.93,12.02c-0.82,5.5,0.7,8.85,0.7,8.85c-0.25,0.7-0.89,11.26-0.89,11.26
		s-1.49,2.91-1.78,8.01s-0.29,6.83,2.5,12.41c2.79,5.58,9.84,8.72,9.84,8.72s3.16,1.93,6.31,3.2c3.16,1.27,8.9,3.49,12.01,4.24
		c3.11,0.75,5.23,1.13,7.91,1.98c2.68,0.85,5.7,1.27,7.49,1.32s3.61-0.12,3.61-0.12c2.14-0.34,5.14-1.19,8.91-3.23
		c8.16-4.41,12.18-12.25,12.76-13.54c0.58-1.3,2.14-4.92,3.11-6.93s2.53-9.85,2.79-11.6c0.26-1.75,0.84-11.4-1.3-16.39
		c-2.14-4.99-7.9-10.04-8.88-10.95s-2.2-2.27-3.3-3.82c-1.1-1.56-5.31-4.41-6.67-5.25c-1.35-0.84-6.28-3.72-6.34-3.75
		c-7.17-0.26-11.06-1.23-12.91-1.61C78.94,223.13,76.25,222.41,73.44,221.75z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 25.0737 193.7557)" className="st1 st2">
            15
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(88, 202, 18)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="88" cy="202" r="12" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="88" cy="202" r="18" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(88, 202, 14)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M102.18,179.25c-1.17-0.7-4.31-1.96-5.48-2.17s-6.7-1.52-9.09-1.96c-2.39-0.43-4.61-1.49-4.61-1.49
		s-4.05-0.63-7.59,0.25c-3.54,0.89-7.27,5.38-7.84,6.13c-0.57,0.76-3.1,3.73-3.79,4.49c-0.7,0.76-4.43,5.25-5.31,7.34
		c-0.89,2.09-1.14,4.49-0.63,6.64c0.51,2.15,0.63,4.43,0.7,6.07c0.06,1.64,0.57,3.29,0.89,4.24c0.32,0.95,1.2,4.36,1.2,4.36
		c1.64,5.06,7.46,6.83,7.46,6.83s2.56,1.11,5.36,1.77c2.81,0.66,5.51,1.38,7.38,1.76c1.85,0.38,5.74,1.35,12.91,1.61
		c0,0-0.01,0-0.01,0s6.28,0.39,10.63-0.52s7.13-2.01,12.7-5.77c5.57-3.76,5.83-10.17,4.99-15.1c-0.84-4.92-5.57-12.83-6.8-14.25
		s-5.05-5.65-5.05-5.65s-1.91-1.11-3.04-1.71C106.01,181.51,103.35,179.94,102.18,179.25z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 46.8074 140.1635)" className="st1 st2">
            14
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(105, 156, 17)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="105" cy="156" r="11" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="105" cy="156" r="17" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(105, 156, 13)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M105.63,127.3c-1.35-0.85-3.72-0.81-3.72-0.81l-2.77,0.27c-3.82,0.3-6.44,2.41-7.45,3.72
		c-1.01,1.31-3.32,3.32-4.13,4.02c-0.8,0.7-3.72,2.72-5.33,4.13s-2.92,3.92-4.23,5.94c-1.31,2.01-1.71,4.63-1.71,5.74
		s-0.6,9.86-0.6,10.46c0,0.6-0.3,2.11,0.7,6.04c1.01,3.92,6.59,6.82,6.59,6.82s2.22,1.06,4.61,1.49c2.39,0.43,7.92,1.74,9.09,1.96
		s4.31,1.48,5.48,2.17s3.83,2.26,4.96,2.87c1.13,0.61,3.04,1.71,3.04,1.71c14.13,1.44,16.26,0.53,21.84-2.06s8.81-8.94,9.27-13.8
		c0.45-4.86-1.88-12.05-4.67-16.52s-8.03-8.49-9.33-9.4c-1.3-0.91-8.49-6.16-8.49-6.16c-1.84-0.79-7.67-4.97-8.45-5.43
		C109.58,130,106.99,128.15,105.63,127.3z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 75.9466 87.2392)" className="st1 st2">
            13
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(127, 108, 16)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="127" cy="108" r="10" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="127" cy="108" r="16" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(127, 108, 12)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M141.43,86.31c-0.53-0.61-3.83-4.52-4.36-5.13c-0.53-0.61-1.22-1.57-1.22-1.57
		c-3.36-1.91-7.92-2.71-10.58-2.51c-2.66,0.2-5.72,2.66-6.22,3.41c-0.5,0.75-1.75,1.75-3.06,3.16c-1.3,1.4-4.21,3.16-5.57,4.01
		c-1.35,0.85-2.56,3.11-2.56,3.11s-2.71,4.46-3.16,5.87c-0.45,1.4-0.35,4.96-0.4,6.77c-0.05,1.8-0.55,3.31-0.9,4.26
		s-0.95,3.16-1,3.81c-0.05,0.65-0.55,2.11-0.85,2.96c-0.3,0.85-1.2,1.91-1.4,5.72c-0.2,3.81,1.75,6.32,1.75,6.32
		s2.36-0.04,3.72,0.81c1.35,0.85,3.94,2.71,4.72,3.17c0.77,0.46,6.61,4.64,8.45,5.43c4.47,1.62,10.43,1.49,15.36,1.23
		c4.92-0.26,9.59-1.23,15.49-4.15c5.9-2.92,6.03-9.78,6.22-13.87s-3.3-11.73-3.89-13.48c-0.58-1.75-3.37-8.16-3.37-8.16
		s-0.81-1.91-1.38-3.13S141.96,86.92,141.43,86.31z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 127.5613 47.6976)" className="st1 st2">
            12
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(161, 75, 15)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="161" cy="75" r="9" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="161" cy="75" r="15" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(161, 75, 11)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M178.37,55.74c-0.56-1.28-2.1-3.76-2.1-3.76c-0.65-1.1-1.91-1.91-1.91-1.91c-1.86-1.15-4.81-0.55-6.42-0.25
		c-1.6,0.3-5.62,2.76-6.92,3.56c-1.3,0.8-6.37,2.46-9.58,3.71c-3.21,1.25-4.81,2.86-6.47,4.56c-1.65,1.7-3.81,2.36-4.91,3.01
		c-1.1,0.65-4.11,2.76-5.11,7.22c-1,4.46,0.9,7.72,0.9,7.72s0.69,0.96,1.22,1.57c0.53,0.61,3.83,4.52,4.36,5.13s5.21,6.81,5.78,8.03
		s1.38,3.13,1.38,3.13s2.59,0.91,4.34,1.81c1.75,0.91,7.65,4.28,11.34,5.18c3.69,0.91,8.16,1.43,12.31-0.71
		c4.15-2.14,5.25-8.55,5.38-10.17c0.13-1.62,0.52-8.16,0.84-11.6c0.32-3.43,0-13.93,0-13.93l-0.48-1.38
		C181.83,64.56,178.93,57.02,178.37,55.74z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 190.0449 22.1687)" className="st1 st2">
            11
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(208, 58, 14)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="208" cy="58" r="8" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="208" cy="58" r="14" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(208, 58, 10)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M237.03,53.62c-0.01-1.13,0-7.31,0-7.31c-0.5-8.02-0.65-11.28-1.96-13.94c-1.3-2.66-4.21-3.26-6.17-3.21
		c-1.96,0.05-6.92,1.15-8.32,1.4s-9.73,1.25-12.53,1.6s-6.07,0.35-10.13,1.7s-10.18,2.06-13.04,2.46c-2.86,0.4-6.77,2.91-7.97,6.27
		c-1.2,3.36-0.65,9.38-0.65,9.38s1.54,2.47,2.1,3.76s3.46,8.82,3.96,10.94l0.48,1.38c0,0,0.78,2.4,2.07,3.63s4.92,5.38,5.96,6.48
		c1.04,1.1,3.63,5.64,5.51,7.78c1.88,2.14,5.7,5.7,7.71,7.13s5.25,4.21,11.47,2.33c6.22-1.88,11.34-10.5,11.99-11.79
		c0.65-1.3,1.94-4.86,2.72-6.61c0.78-1.75,1.88-6.41,2.33-8.16c0.45-1.75,1.75-5.31,2.85-7.13c1.1-1.81,1.49-5.44,1.49-5.44
		c0.01,0.05,0.02,0.12,0.04,0.18l0-0.01C236.95,56.44,237.05,54.76,237.03,53.62z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 260.9633 21.0351)" className="st1 st2">
            21
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(265, 58, 14)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="265" cy="58" r="8" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="265" cy="58" r="14" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(265, 58, 10)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M295.17,58.06c0.61-1.72,3.68-7.63,3.68-7.63s0.4-3.21,0-6.57s-1.85-4.66-3.91-6.52
		c-2.06-1.86-5.16-2.46-7.52-2.61s-8.07-1.5-10.23-1.91c-2.16-0.4-5.87-2.61-10.08-2.41s-8.77-0.15-8.77-0.15
		c-4.46-0.4-5.11-0.35-9.07-1.35s-6.57-0.35-6.57-0.35c-4.46,1.55-4.66,4.36-4.96,5.46c-0.3,1.1-0.7,12.28-0.7,12.28
		s-0.01,6.17,0,7.31s-0.09,2.81-0.09,2.81l0,0.01c0.26,1.25,0.62,3.95,2.3,7.73c1.75,3.95,6.29,12.63,9.52,17.3
		c3.24,4.67,6.09,8.16,9.85,9.85s8.29,0.32,11.99-1.62c3.69-1.94,11.86-10.43,12.89-11.34s7.84-8.23,7.84-8.23s0.99-3.17,1.32-4.01
		C293,65.29,294.56,59.79,295.17,58.06z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 322.0563 40.4583)" className="st1 st2">
            22
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(315, 73, 15)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="315" cy="73" r="9" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="315" cy="73" r="15" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(315, 73, 11)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M340.92,79.06c2.51-3.86,2.71-7.87,2.56-10.43s-2.11-5.21-2.46-5.67c-0.35-0.45-2.36-2.31-6.37-4.56
		c-4.01-2.26-6.17-4.51-7.87-5.51c-1.7-1-4.11-1.96-5.26-2.36c-1.15-0.4-2.71-1.4-8.27-3.31c-5.57-1.91-7.37-1.45-7.37-1.45
		c-4.61,0.45-7.02,4.66-7.02,4.66s-3.07,5.91-3.68,7.63c-0.61,1.72-2.17,7.23-2.5,8.07c-0.33,0.83-1.32,4.01-1.32,4.01
		c-0.13,5.7,1.21,8.21,1.27,10.22c0.06,2.01,0.67,5.98,0.8,9.74c0.13,3.76,1.36,6.87,4.08,10.5c2.72,3.63,6.87,2.98,10.69,2.92
		c3.82-0.06,9.85-3.24,10.76-4.08c0.91-0.84,4.21-3.11,5.9-3.56s4.86-2.14,4.86-2.14c0.86-1.02,4.57-7.03,5.67-8.66
		C336.47,83.42,340.92,79.06,340.92,79.06z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 380.8362 91.158)" className="st1 st2">
            23
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(351, 106, 16)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="351" cy="106" r="10" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="351" cy="106" r="16" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(351, 106, 12)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M370.56,129.89c2.1-1.07,3.9-1.7,3.9-1.7c1.6-1.86,3.01-5.06,3.46-7.22c0.45-2.16,0.15-5.21-0.3-7.07
		s-0.65-5.92-0.8-7.62c-0.15-1.7-0.8-5.62-1.6-7.37s-1.2-4.16-2.46-6.97s-2.56-4.31-3.36-4.96c-0.8-0.65-3.66-2.16-4.41-3.01
		c-0.75-0.85-2.91-3.26-5.26-4.81c-2.36-1.55-3.71-3.96-9.93-3.96c-4.64,0-7.29,2.15-8.34,3.24l-0.53,0.62c0,0-4.44,4.37-5.55,6
		c-1.11,1.63-4.81,7.64-5.67,8.66c0,0-4.02,9.14-4.73,11.4c-0.71,2.27-2.98,9.2-3.63,15.23c-0.65,6.03,1.17,9.91,3.05,11.92
		c1.88,2.01,6.16,3.89,8.42,4.6c2.27,0.71,3.63,0.52,5.18,0.65c1.56,0.13,8.42,0,11.86,0.06c3.43,0.06,9.33-1.68,9.33-1.68
		c1.97-0.53,3.36-1.19,4.72-1.89C365.25,133.31,370.56,129.89,370.56,129.89z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 413.6709 143.7692)" className="st1 st2">
            24
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(374, 155, 17)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="374" cy="155" r="11" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="374" cy="155" r="17" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(374, 155, 13)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M396.87,175.77c2.91-1.1,4.66-4.66,5.16-6.77c0.5-2.11,1.4-8.22,1.15-12.83c-0.25-4.61-1.1-9.02-3.21-12.48
		s-3.01-3.81-4.16-4.71c-1.15-0.9-1.96-2.21-3.21-3.31c-1.25-1.1-4.56-4.16-8.92-6.57c-4.36-2.41-9.23-0.9-9.23-0.9
		s-1.8,0.63-3.9,1.7c0,0-5.31,3.42-6.67,4.11c-1.36,0.7-2.74,1.36-4.72,1.89c-0.84,0.58-3.56,2.07-4.54,2.98s-4.41,3.3-7.13,5.25
		c-2.72,1.94-5.57,5.51-5.96,6.22c-0.39,0.71-3.43,5.9-4.28,9.46s-1.23,6.74,1.04,11.79s5.9,7.45,9.59,9.27s7.32,1.75,11.53,2.4
		c4.21,0.65,9.4-0.45,10.63-0.71c1.23-0.26,9.01-1.75,9.01-1.75c3.15-0.61,11.2-3.35,12.54-3.75S396.87,175.77,396.87,175.77z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 430.5352 198.452)" className="st1 st2">
            25
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(390, 202, 18)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="390" cy="202" r="12" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="390" cy="202" r="18" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(390, 202, 14)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M407.45,224.4c3.91-1.11,5.92-2.31,5.92-2.31c3.56-1.91,4.51-4.31,4.96-5.31c0.45-1,1.05-3.46,1.4-4.46
		c0.35-1,0.5-3.36,0.95-5.72c0.45-2.36,0.45-4.91,0.3-6.42s-0.35-4.71-0.8-6.07c-0.45-1.35-2.31-4.76-4.16-6.37
		c-1.86-1.6-6.52-6.47-9.98-9.38s-9.17-2.61-9.17-2.61s-3.93,0.87-5.26,1.28s-9.38,3.15-12.54,3.75c0,0-7.58,4.41-12.05,8.29
		c-4.47,3.89-8.68,9.2-10.89,12.38c-2.2,3.17-3.11,9.33-1.1,13.22c2.01,3.89,6.93,8.81,9.85,10.76c2.92,1.94,10.24,2.92,11.34,3.11
		c1.1,0.19,9.78,0.06,9.78,0.06c5-0.04,6.24-0.59,8.7-1.22C397.17,226.77,403.54,225.51,407.45,224.4z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 446.7902 257.2819)" className="st1 st2">
            26
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(400, 263, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="400" cy="263" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="400" cy="263" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(400, 263, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M393.06,303.67c3.21-0.65,7.46-3.27,7.46-3.27c3.93-0.2,9.82-2.82,9.82-2.82c2.42,0.07,9.3-1.64,13.68-2.88
		c4.39-1.24,6.08-2.56,6.08-2.56c6.57-3.96,7.72-9.43,8.22-11.58c0.5-2.16,0.9-7.37,0.4-11.18c-0.5-3.81-3.01-7.72-3.01-7.72
		c0.2-5.01-1-11.13-1-11.13c0.9-1.75,0.7-6.52,0.6-7.47c-0.1-0.95-0.45-2.11-0.55-3.06c-0.1-0.95-0.2-1.75-0.2-1.75
		c-0.5-2.51-3.76-7.42-5.21-8.97c-1.45-1.55-4.76-4.06-8.28-5.62c-3.52-1.55-7.71-1.55-7.71-1.55s-2.01,1.2-5.92,2.31
		c-3.91,1.11-10.28,2.36-12.74,2.99c-2.46,0.63-3.7,1.18-8.7,1.22c-2.2,0.58-5.38,2.33-6.29,2.98s-5.44,3.63-6.41,4.15
		s-3.56,2.07-6.87,4.73c-3.3,2.66-8.68,8.81-9.14,17.56c-0.45,8.75,1.3,14.25,2.79,18.92s3.69,8.62,4.47,10.04
		c0.78,1.43,4.02,5.83,5.05,7.06s3.3,3.43,5.38,4.67c2.07,1.23,3.24,2.79,5.18,3.89c1.94,1.1,5.83,1.47,5.83,1.47
		C386.74,304.13,389.85,304.32,393.06,303.67z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 453.2419 326.7139)" className="st1 st2">
            27
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(408, 330, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="408" cy="330" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="408" cy="330" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(408, 330, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M443.14,322.82c0.95-2.06,1.7-5.62,1.45-9.28s-3.61-9.68-4.21-10.73c-0.6-1.05-3.41-5.16-5.11-6.87
		c-1.7-1.7-5.16-3.81-5.16-3.81s-1.69,1.32-6.08,2.56c-4.39,1.24-11.26,2.95-13.68,2.88c0,0-5.89,2.62-9.82,2.82
		c0,0-4.26,2.62-7.46,3.27c-3.21,0.65-6.33,0.47-7.06,0.41c0,0-6.22,1.64-9.98,3.26c-3.76,1.62-7.56,3.67-9.13,9.01
		c-1.57,5.34,0.06,12.99,1.28,17.22c1.22,4.23,4.47,11.83,5.74,13.45s5.51,7.42,11.37,11.42c4.96,3.39,10.07,4.45,11.52,4.7
		l0.42,0.07c3.56,0.82,9.35-0.02,10.72-0.27c1.37-0.25,7.61-2.06,9.04-2.43s7.4-1.84,7.4-1.84s6.27-1.6,9.68-3.51
		c3.41-1.91,5.06-3.16,7.07-7.27c2.01-4.11,1.55-8.42,1.5-10.63c-0.05-2.21-1.5-6.32-1.91-7.17c-0.4-0.85-0.35-2.16-0.35-2.16
		C441.94,325.93,442.19,324.87,443.14,322.82z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 452.1075 391.369)" className="st1 st2">
            28
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(410, 390, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="410" cy="390" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="410" cy="390" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(410, 390, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M407.95,362.94c-1.37,0.25-7.16,1.09-10.72,0.27c0,0-4.98-0.47-9.96-0.2c-4.98,0.27-7.27,1.21-10.43,2.69
		c-3.16,1.48-4.24,3.19-5.77,7.34c-1.53,4.15-0.74,10.73-0.57,13.06s1.31,9.54,3.07,12.61c1.76,3.07,4.37,7.21,7.33,10.34
		c2.95,3.12,5.79,5.23,10.39,6.93c4.6,1.7,10.89,1.23,10.89,1.23s12.59-0.62,16.67-1.23c4.07-0.62,10-1.98,12.72-5.43
		c2.72-3.46,3.52-7.96,3.82-10.46c0.3-2.51-0.6-5.97-0.7-6.42c-0.1-0.45,0.2-1.65,0.2-1.65c1.55-1.25,2.41-2.81,3.91-5.62
		c1.5-2.81,2.26-5.11,1.75-9.73c-0.5-4.61-2.81-8.97-3.56-10.68s-1.45-2.61-4.11-4.41s-8.47-2.91-8.47-2.91s-5.97,1.47-7.4,1.84
		S409.32,362.69,407.95,362.94z"
          />
        </g>
        {/* lower */}
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 452.1075 500.7621)" className="st1 st2">
            38
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(406, 493, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="406" cy="493" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="406" cy="493" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(406, 493, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M401.91,458.32c0,0-10.01-0.27-16.83,4.64c-6.82,4.91-10.37,12.47-11.74,16.93s-1.64,10.28-1.73,11.92
		c-0.09,1.64-0.73,12.1,0,16.47c0.73,4.37,1.35,6.97,1.79,8.42c0.44,1.44,1.57,3.14,3.96,4.46c2.39,1.32,5.46,3.01,7.03,3.77
		c1.57,0.75,6.8,3.32,9.18,3.39c0,0,1.82,0.24,5.81,0.16c3.99-0.08,8.75,0.28,10.56,0.4c1.81,0.12,3.22,0,5.96-1.09
		s4.84-2.38,6.65-3.51c1.81-1.13,3.83-2.58,5.16-3.79c1.33-1.21,3.71-3.83,5.28-6.81c1.57-2.98,2.5-6.33,2.74-7.98
		c0.24-1.65,0.85-4.72,1.01-5.8c0.16-1.09,0.73-5.2,0.77-7.17c0.04-1.97,0.44-6.89-0.44-10.36c-0.89-3.47-1.93-6.77-2.66-8.06
		s-2.22-3.83-4.43-6.21s-6.21-5.88-7.33-6.49c-1.13-0.6-5.36-2.22-7.86-2.62C412.28,458.59,404.7,458.21,401.91,458.32z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 444.5219 582.3543)" className="st1 st2">
            37
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(397, 565, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="397" cy="565" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="397" cy="565" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(397, 565, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M431.61,560.23c-0.16-2.55-0.78-7.84-2-10.66s-3.37-6.62-5.37-8.94c-2-2.31-3.61-4.43-6.43-6.04
		c-2.82-1.61-8.7-3.65-13.29-4.47c-4.59-0.82-11-1.23-14.16-1c-3.16,0.22-10.68,1.75-14.89,5.54c-4.21,3.8-8.62,8.94-10.6,14.96
		s-3.28,14.15-3.55,15.25c-0.27,1.11-1.11,5.91-1.18,8.43c-0.08,2.52-0.08,6.9,0.11,8.31c0.19,1.41,0.08,2.02,0.08,2.44
		s-0.3,2.4,1.53,4.5c1.83,2.1,6.41,5.45,7.44,6.14c1.03,0.69,5.57,3.66,6.79,4.27s3.55,1.83,4.96,2.25c3.11,0.57,6.5,0.67,8.92,1.4
		c2.42,0.73,7.55,1.44,7.55,1.44s2.74,0,6.08-0.86c3.33-0.86,5.8-1.92,6.82-2.47c1.02-0.55,2.98-1.37,3.8-1.8
		c0.82-0.43,3.18-1.84,5.49-4.12s4.43-5.25,5.64-8.15c1.22-2.9,2.67-7.41,3.02-8.39c0.35-0.98,1.45-3.88,1.65-4.98
		s0.67-2.98,0.94-4.51S431.77,562.77,431.61,560.23z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 427.4145 659.2745)" className="st1 st2">
            36
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(377, 636, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="377" cy="636" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="377" cy="636" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(377, 636, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M381.04,601.21c0,0-6.18-0.27-9.38-0.19c-3.2,0.08-9.23,1.18-12.81,3.28s-7.37,6.08-8.82,7.88
		s-3.05,5.71-3.56,6.95c-0.51,1.24-2.14,6.69-2.53,7.59s-1.24,6.13-1.37,6.95c-0.13,0.82-1.8,9.05-1.63,12.57
		c0.17,3.52,1.8,8.49,2.14,9.39s3.17,6.43,4.12,7.64c0.94,1.2,2.19,2.83,2.7,3.6s2.19,2.66,3.35,3.3c2.26,1.02,3.6,1.18,4.6,1.65
		c1,0.47,2.93,1.33,4.46,1.87s4.93,1.73,7.26,2.8c2.33,1.07,5.48,1.61,5.48,1.61s3.29,0.67,6.19-0.12s5.37-1.76,5.92-2
		c0.55-0.24,3.96-1.72,6-3.41c2.04-1.69,5.33-4.12,7.37-6.31s3.72-5.33,4.66-7.33c0.94-2,2.63-5.88,3.14-7.33
		c0.51-1.45,3.29-8.19,3.76-11.88c0.47-3.68,0.78-7.64-0.31-11.49c-1.1-3.84-2.04-5.29-2.94-6.82c-0.9-1.53-2.43-3.68-3.14-5.72
		c-0.71-2.04-1.02-4.08-2.63-6.19c-1.61-2.12-3.14-4.78-5.57-5.45c0,0-5.13-0.71-7.55-1.44
		C387.54,601.88,384.15,601.78,381.04,601.21z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 405.4116 721.4319)" className="st1 st2">
            35
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(360, 692, 18)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="360" cy="692" r="12" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="360" cy="692" r="18" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(360, 692, 14)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M362.31,673.69c-1.53-0.53-3.46-1.4-4.46-1.87c-1-0.47-2.35-0.63-4.6-1.65c0,0-1.87-0.35-4.97,0.42
		s-8.29,4.59-9.12,5.37s-4.35,5.01-5.54,8.47c-1.19,3.46-2.33,6.92-1.79,12.46s1.25,7.99,1.91,9.48c0.61,1.39,2.67,4.43,3.58,5.37
		c0.06,0.06,0.12,0.11,0.18,0.17c3.16,3.35,8.37,5.81,9.58,6.26c1.21,0.45,4.22,1.57,6.1,2.74c1.88,1.17,4.13,2.33,4.13,2.33
		c1.66,0.63,3.15,0.92,3.15,0.92l0.39,0.01c0.55,0,1.65-0.08,3.17-0.49c2.2-0.61,5.69-1.88,6.47-2.48c0.78-0.61,3.64-3.29,4.57-4.28
		c0.92-0.98,1.47-1.44,2.92-2.57c1.44-1.13,3.99-3.09,5.32-5.49c1.33-2.4,2.37-4.91,2.37-7.22s-0.43-6.21-0.95-7.92
		c-0.52-1.7-2.11-6.87-3.01-8.6c-0.9-1.72-2.9-5.49-6.62-7.02c0,0-3.15-0.55-5.48-1.61C367.24,675.42,363.84,674.22,362.31,673.69z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 376.72 776.4886)" className="st1 st2">
            34
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(344, 734, 17)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="344" cy="734" r="11" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="344" cy="734" r="17" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(344, 734, 13)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M353.17,720.91c-1.88-1.17-4.89-2.29-6.1-2.74c-1.21-0.45-6.41-2.91-9.58-6.26c0,0-4.95,2.09-6.5,3.04
		c-1.55,0.95-8.29,4.23-9.9,7.51c-1.61,3.28-1.91,7.75-2.03,9.48c-0.12,1.73,0.78,6.5,1.25,8.41c0.48,1.91,3.4,9.6,4.35,11.33
		s3.1,4.95,4.47,6.56c0,0,2.95,3.08,5.13,5.15s4.21,2.82,4.21,2.82s3.11,0.69,3.91,0.94c0.79,0.25,3.36-0.15,5.09-0.99
		s2.47-1.68,4.05-2.67c1.58-0.99,5.09-2.37,5.98-3.07c0.89-0.69,1.09-0.99,1.93-1.98c0.84-0.99,3.11-3.76,3.76-5.14
		s2.13-4.9,2.47-7.27c0.35-2.37,0.2-4.99,0.4-6.68s0-4.75-0.54-7.17s-1.58-5.64-3.36-6.97c0,0-1.18-0.74-1.73-1.06
		c0,0-1.49-0.29-3.15-0.92C357.29,723.25,355.05,722.08,353.17,720.91z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 341.1811 820.3192)" className="st1 st2">
            33
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(318, 772, 16)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="318" cy="772" r="10" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="318" cy="772" r="16" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(318, 772, 12)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M329.14,758.24c0,0-3.46-2.92-4.11-3.22c-0.66-0.3-2.86-0.54-5.01-1.43s-6.2-3.1-8.76-3.52
		c-2.56-0.42-6.62-0.3-9.06,1.49c-2.44,1.79-5.6,6.32-5.78,10.79s-0.12,8.65,0.54,11.63c0.66,2.98,1.43,7.27,1.49,8.59
		c0.06,1.31,1.01,6.5,1.01,6.5c1.89,2.31,4.31,6.95,4.93,8.18c0.61,1.22,2.76,4.23,2.76,4.23s1.93,2.42,3.31,3.31
		s2.72,1.29,4.7,1.38c1.98,0.1,4.65-1.14,5.34-1.34c0.69-0.2,4.85-1.93,5.98-2.32s2.87-1.58,3.36-2.13
		c0.49-0.54,2.23-2.18,2.82-3.71c0.59-1.53,1.63-4.01,1.98-5.24s0.35-3.86,1.83-6.87c1.48-3.02,2.27-5.64,3.31-7.37
		c1.04-1.73,1.68-7.61-1.29-10.98c0,0-2.03-0.75-4.21-2.82S329.14,758.24,329.14,758.24z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 292.3718 849.3515)" className="st1 st2">
            32
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(286, 797, 15)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="286" cy="797" r="9" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="286" cy="797" r="15" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(286, 797, 11)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M299.45,789.07c0,0-3.94-4.83-4.89-5.9c-0.95-1.07-3.46-3.82-4.35-5.25c-0.89-1.43-2.38-2.62-3.46-3.46
		s-1.91-1.73-3.04-2.03c-1.13-0.3-3.76-1.49-6.02-0.54c-2.27,0.95-3.76,2.74-4.89,6.44s-2.62,9.96-2.92,12.58
		c-0.3,2.62-1.19,9.24-1.13,11.86c0,0,0.75,2.25,1.03,3.75s0.67,6.17,0.72,7.23c0.06,1.06,0.74,4.57,0.74,4.57s0,0.02,0.01,0.05
		c0.06,0.34,0.48,2.46,1.57,3.46c1.19,1.09,2.62,2.37,4.75,2.42s2.87-0.64,4.45-1.14s3.36-1.24,6.13-2.03s3.26-0.79,4.94-1.68
		c1.68-0.89,4.45-2.23,5.09-2.72s2.82-1.73,5.34-3.02c2.52-1.29,3.46-1.93,4.1-3.61c0.64-1.68,1.33-3.61,0.79-5.44
		c-0.54-1.83-1.29-3.16-1.29-3.16s-2.15-3-2.76-4.23C303.76,796.02,301.34,791.38,299.45,789.07z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 246.3988 857.1611)" className="st1 st2">
            31
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(254, 805, 14)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="254" cy="805" r="8" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="254" cy="805" r="14" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(254, 805, 10)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M270.49,813.77c-0.06-1.06-0.45-5.73-0.72-7.23s-1.03-3.75-1.03-3.75s-3.46-7.39-4.47-9.54
		c-1.01-2.15-4.35-8.82-6.26-11.39c-1.91-2.56-5.07-7.04-9.66-6.5c-4.59,0.54-6.92,8.82-7.69,12.34c-0.78,3.52-3.52,15.2-3.52,15.2
		s0.31,2.82,0.31,4.18s0.63,8.11,0.67,10.88c0.05,2.78-0.23,6.9-0.23,6.9s0,2.02,1.58,3.04c1.58,1.01,3.72,1.01,6.29,0.91
		c2.57-0.1,3.21-0.2,4.7-0.2s4.45,0.2,6.68-0.35c2.22-0.54,4.25-0.89,5.49-0.99c1.24-0.1,4.5-0.2,5.44-0.74
		c0.94-0.54,1.93-2.42,2.32-3.02c0.4-0.59,0.74-1.29,0.84-3.07c0.05-0.94,0.05-1.47,0.03-1.77l-0.03-0.36
		C271.24,818.34,270.55,814.83,270.49,813.77z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 207.7609 857.1611)" className="st1 st2">
            41
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(221, 805, 14)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="221" cy="805" r="8" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="221" cy="805" r="14" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(221, 805, 10)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M238.13,817.97c-0.05-2.78-0.67-9.52-0.67-10.88s-0.31-4.18-0.31-4.18s-3.4-9.54-4.59-12.4
		c-1.19-2.86-5.72-14.07-10.49-14.01c-4.77,0.06-7.57,5.9-9.6,10.08c-2.03,4.17-6.37,15.55-6.37,15.55s-0.45,2.85-0.59,3.74
		c-0.14,0.89-1.26,6.48-1.72,8.67c-0.47,2.19-1.48,5.41-1.48,5.41s-0.32,2.15,1.14,3.6s2.4,2.34,4.81,2.85s4.49,0.82,7.15,1.14
		c2.66,0.32,6.01,1.08,8.28,1.2c2.28,0.13,10.18,0.25,11.45-0.57s2.59-1.83,2.78-3.29C237.9,824.87,238.17,820.74,238.13,817.97z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 162.7702 846.6511)" className="st1 st2">
            42
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(188, 797, 15)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="188" cy="797" r="9" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="188" cy="797" r="15" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(188, 797, 11)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M205.5,805.85c0.14-0.89,0.59-3.74,0.59-3.74s-0.07-12.21-0.85-16.45c0,0-1.37-10.31-3.82-12.84
		c-2.28-2.36-6.67-3.14-11.27-0.1c-4.59,3.04-13.36,12.27-16.04,15.31c0,0-2.32,4.35-2.82,5.4c-0.5,1.05-2.56,3.96-2.56,3.96l0,0
		c-0.36,0.86-1.59,3.98-1.48,5.71c0.13,2.02,0.57,3.79,1.58,5.12c1.01,1.33,3.1,3.1,4.49,3.54s2.02,0.63,2.85,1.14
		s4.93,3.04,6.45,3.73c1.52,0.7,6.89,2.91,8.16,3.29c1.26,0.38,4.87,1.9,5.88,2.15c1.01,0.25,2.28,0.38,4.24-0.51
		c0,0,0.95-0.44,1.39-1.64c0,0,1.01-3.22,1.48-5.41C204.24,812.33,205.36,806.74,205.5,805.85z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 115.2002 820.3195)" className="st1 st2">
            43
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(157, 772, 16)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="157" cy="772" r="10" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="157" cy="772" r="16" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(157, 772, 12)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M171.3,793.44c0.5-1.05,2.82-5.4,2.82-5.4s2.01-7.01,2.47-8.27c0.46-1.26,2.01-7.98,2.41-8.9
		s1.89-4.94,2.12-7.12c0.23-2.18,1.72-9.35-0.69-12.68s-5.28-4.65-10.1-4.3s-9.53,1.61-11.02,2.01c-1.49,0.4-2.41,0.57-4.42,0.98
		s-5.17,0.86-8.21,2.75c-0.96,1.66-2.46,3.91-2.86,4.38c-0.4,0.46-4.07,4.1-4.93,4.66c-0.86,0.56-1.8,0.83-1.8,0.83
		s-1.71,2.15-1.52,5.94c0.19,3.79,0.44,8.28,0.89,9.68s1.64,4.3,1.96,5.63s0.95,3.73,2.02,5.63c1.08,1.9,2.21,4.17,7.65,8.28
		s12.4,3.73,13.15,3.67s3.86-0.38,5.19-1.58c1.33-1.2,2.4-2.47,2.4-2.47s-0.04,0.09-0.1,0.23l0,0
		C168.74,797.4,170.8,794.49,171.3,793.44z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 76.7689 773.7032)" className="st1 st2">
            44
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(130, 734, 17)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="130" cy="734" r="11" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="130" cy="734" r="17" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(130, 734, 13)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M143.82,756.89c0.4-0.46,1.9-2.71,2.86-4.38c0,0,2.93-5.05,3.27-5.85s2.01-3.85,2.7-5.45
		c0.69-1.61,1.43-4.3,1.55-6.6c0.11-2.3,0.11-6.2-1.43-10.16c-1.55-3.96-4.71-6.89-6.31-8.09c-1.61-1.21-5.51-3.21-7.58-3.21
		s-4.48-0.46-8.38,0.17c-1.54,1.09-5.72,3.17-7,3.84s-5.97,2.9-7.15,3.41c-1.17,0.5-2.47,0.84-2.47,0.84s-1.26,0.57-1.64,1.39
		c-0.38,0.82-1.77,3.48-2.02,5.19c-0.25,1.71-0.63,5.31-0.89,6.7c-0.25,1.39-0.63,2.21-0.38,4.24c0.25,2.02,1.2,7.02,3.35,10.12
		s6.83,6.58,6.83,6.58s5.44,3.92,6.7,4.87s3.54,2.09,7.08,2.28c3.54,0.19,4.17-0.38,4.17-0.38s0.94-0.27,1.8-0.83
		C139.76,760.99,143.43,757.35,143.82,756.89z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 51.0444 720.8649)" className="st1 st2">
            45
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(112, 692, 18)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="112" cy="692" r="12" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="112" cy="692" r="18" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(112, 692, 14)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M123.5,717.16c1.28-0.67,5.46-2.75,7-3.84c0,0,4.42-2.93,6.43-5.51s5.22-6.43,6.26-10.62
		c1.03-4.19,0.69-10.27-0.98-14.41c-1.66-4.13-3.73-6.54-5.39-8.03s-3.39-3.1-4.53-3.73c-1.15-0.63-3.21-1.26-4.71-1.55
		c-1.49-0.29-2.47-0.57-3.1-0.8c-0.63-0.23-3.16-0.75-4.88-0.52c-1.38,0.18-4,0.81-5,1.05c0,0-2.8,1.08-3.69,1.46
		c-0.89,0.38-5.07,2.17-6.35,2.6c-1.28,0.43-5.52,1.58-5.52,1.58s-1.92,0.91-3.06,2.49c0,0-1.39,1.45-1.83,1.83s-1.71,2.02-2.4,5.12
		c-0.7,3.1-1.71,9.04-1.52,11.32c0.19,2.28,0.06,3.86,0.13,4.81c0.06,0.95,0.95,4.43,2.91,7.34c1.96,2.91,3.04,4.3,3.98,5.31
		s4.62,3.98,7.08,5.31s4.87,2.97,6.7,3.04c1.83,0.06,2.85,0,2.85,0s1.3-0.34,2.47-0.84C117.52,720.06,122.21,717.83,123.5,717.16z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 31.6854 658.1407)" className="st1 st2">
            46
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(98, 632, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="98" cy="632" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="98" cy="632" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(98, 632, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M110.91,670.66c0.89-0.38,3.69-1.46,3.69-1.46c-0.25,0.06-0.4,0.1-0.4,0.1s5.11-1.89,6.71-2.93
		s1.15-1.15,3.62-2.93c2.47-1.78,4.13-3.27,5.8-4.99c1.66-1.72,2.7-3.5,3.5-4.76c0.8-1.26,1.84-4.02,2.18-6.03
		c0.34-2.01,0.86-7.23,0.63-10.67c-0.23-3.44-1.78-10.56-2.58-13.03c-0.8-2.47-3.67-10.67-4.65-12.63c-0.98-1.95-2.93-5.34-5.8-7.46
		c-2.87-2.12-4.99-3.44-6.94-3.9c-1.95-0.46-6.37-1.26-10.04-1.55c-3.67-0.29-14.11-0.17-17.21,0.11c0,0-4.17,0.61-5.17,0.75
		c-1,0.14-4.39,0.76-4.39,0.76s-2.4,0.57-3.6,2.78c0,0-1.96,2.4-2.21,4.05c-0.25,1.64-0.76,4.87-0.76,4.87s-2.91,3.98-3.41,5.06
		c0,0-2.28,1.9-3.1,4.93c-0.82,3.04-1.14,8.47,0.32,15.81c1.45,7.34,3.6,12.71,4.62,15.37c1.01,2.66,3.16,9.68,9.3,15.05
		c6.13,5.38,11.07,5.63,12.02,5.82c0.95,0.19,4.51,1.24,6.03,1.05c0,0,4.24-1.15,5.52-1.58
		C105.84,672.83,110.01,671.04,110.91,670.66z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 17.3382 582.3546)" className="st1 st2">
            47
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(85, 560, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="85" cy="560" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="85" cy="560" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(85, 560, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M89.41,598.53c0,0,3.58-1.16,6.01-1.32s6.09-0.74,7.31-1.64c1.22-0.9,2.6-1.75,3.55-2.28s6.41-3.5,7.68-4.82
		c1.27-1.32,4.61-4.13,5.56-7.26s1.7-7.05,1.8-10.33c0.11-3.29-0.42-8.48-0.95-11.87c-0.53-3.39-0.95-5.03-1.17-6.57
		s-1.48-6.31-2.23-7.79c-0.74-1.48-2.76-7.05-5.51-9.75c-2.76-2.7-6.31-4.99-9.12-5.83c-2.81-0.84-8.48-1.8-10.86-1.96
		c-2.38-0.16-13.66-1.06-19.45,1.13c-5.8,2.19-10.72,6.87-10.72,6.87s-4.74,4.11-6.83,11.07c-2.09,6.96-2.53,12.02-1.52,18.4
		c0,0,0.63,4.05,1.01,5.57c0.38,1.52,0.7,2.66,1.01,3.73c0.32,1.08,2.02,6.89,4.55,10.06c2.53,3.16,3.73,4.74,4.62,5.5
		c0,0,2.02,1.77,3.54,3.29s2.91,2.97,3.86,3.6s5.25,3.73,8.28,3.73c0,0,3.39-0.62,4.39-0.76C85.24,599.14,89.41,598.53,89.41,598.53
		z"
          />
        </g>
        <g data-role="teeth">
          <text transform="matrix(1 0 0 1 11.0265 505.0031)" className="st1 st2">
            48
          </text>
          <g data-role="pim">
            <polygon className="st0" points={hexagonPoints(75, 490, 22)} fill="rgba(0,0,0,0)" />
            <circle className="st0" cx="75" cy="490" r="14" fill="rgba(255,255,255,0)" />
          </g>
          <g data-role="abutment">
            <circle className="st0" cx="75" cy="490" r="22" fill="rgba(0,0,0,0)" />
            <polygon
              className="st0"
              points={hexagonPoints(75, 490, 18)}
              fill="rgba(255,255,255,0)"
            />
          </g>
          <path
            className="st3"
            d="M56.92,464.42c0,0-3.75,2.84-6.8,9.1c-3.05,6.25-3.46,13.33-3.05,19.42c0.41,6.09,1.81,12.84,3.05,14.73
		s2.88,4.69,3.62,5.84s4.2,4.86,5.1,6.09c0.91,1.23,4.44,4.69,6.17,5.6c1.73,0.91,2.72,1.48,5.35,1.32s4.69,0.22,6.58,0.03
		c1.89-0.19,2.72-0.77,5.1-0.77s5.68,0.08,7.9-0.82s2.8-1.56,5.68-2.72c2.88-1.15,7.24-3.37,9.63-6.09s4.28-6.91,4.77-10.2
		c0.49-3.29,0.9-6.1,0.85-9.54c-0.05-3.44-0.71-7.27-0.71-8.91s-0.98-8.09-2.19-12.03c-1.2-3.94-3.28-7.6-7.11-10.66
		s-8.69-4.21-10.22-4.65c-1.53-0.44-5.58-1.09-7.05-1.48s-6.72-0.93-8.04-0.98c-1.31-0.05-4.7-0.33-8.42,1.04
		C63.43,460.09,58.75,462.69,56.92,464.42z"
          />
        </g>
      </g>
    </>
  );
}
